import * as React from 'react';
import { getBaseUrl } from '@/redux/modules/config';
import { getIntellectualPropertyUrl } from '@/utils/urls';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

const IntellectualPropertyPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'intellectual_property' }));
    const ipUrl = getIntellectualPropertyUrl();
    const canonical = `${baseUrl}${ipUrl}`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default IntellectualPropertyPageHeaderMeta;
